<template>
  <b-card title="DETTAGLIO ANNO">

    <Spinner v-if="loading" />

    <!-- <div v-else-if="chartOptions && series.length">
      <apexchart type="bar" height="350" :options="chartOptions" :series="series" />
    </div> -->
    <div>
      <div style="height:400px;" :id="chartId"></div>
    </div>
  </b-card>
</template>

<script>
import vectorMixin from './vector';
import chartMixin from './chart';
import moment from 'moment';
import { ACTION_CONSUMPTION_MONTHLY } from '@/store/modules/dashboard/actions';
import { makeid } from './helpers';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";

const YEAR_FORMAT = 'YYYY';
const MONTH_DATE_FORMAT = 'MMM YYYY';

export default {
  props: {
    vector: {
      type: String,
      required: true,
    },
  },

  mixins: [vectorMixin, chartMixin],

  data: () => ({
    chartId: makeid(),

    consumption: null,

    series: [],
    chartOptions: null,
    chart: undefined
  }),

  mounted() {
    this.setChartOptions();
  },

  beforeDestroy() {
    this.unload();
  },

  methods: {
    async loadData(force = false) {
      if (this.loading && !force) {
        return;
      }

      // Comment this part because it prevent data rendering in multi user page (bugname/289-multi-site-dashboard-changing-site-wont-refresh-the-dettaglio-anno-chart)

      /*// Prevent load again because current widget don't belong to a date
      if (this.series.length) {
        return;
      }*/

      try {
        this.loading = true;

        this.consumption = await this.$store.dispatch(
          `dashboard/${ACTION_CONSUMPTION_MONTHLY}`,
          {
            vector: this.vector,
          },
        );

        this.setChartData();
      } catch (e) {
        console.error(e);
      }

      this.loading = false;

    },

    setChartData() {
      // Setup MU as title
      this.chartOptions.yaxis.title.text = `[${this.consumption[0].mus[0]}]`;

      const currentYearValues = this.consumption[0].values;
      const previousYearValues = this.consumption[1].values;

      const currentYear = moment(currentYearValues[0][0]);
      const previousYear = moment(previousYearValues[0][0]);
      let seriesData = [
        {
          name: currentYear.format(YEAR_FORMAT),
          data: currentYearValues.map(([, value]) => (value ? value : null)),
        },
        {
          name: previousYear.format(YEAR_FORMAT),
          data: previousYearValues.map(([, value]) => (value)),
        },
      ];
      this.series = seriesData;

      this.chartOptions.xaxis.categories = currentYearValues.map(([date]) => (date));
      this.setAmChart(seriesData);
    },

    setChartOptions() {
      this.chartOptions = {
        ...this.defaultChartOptions,

        tooltip: {
          x: {
            formatter: (val, { dataPointIndex }) => {
              return moment(this.chartOptions.xaxis.categories[dataPointIndex]).format(MONTH_DATE_FORMAT);
            },
          },
          y: {
            formatter: (val) => {
              return this.$options.filters.formatDecimal(val);
            },
          },
        },

        xaxis: {
          categories: [],
          labels: {
            show: true,
            hideOverlappingLabels: true,

            formatter: (val) => {
              return moment(val).format(MONTH_DATE_FORMAT);
            },
          },
          tooltip: { enabled: false },
        },

        yaxis: {
          title: { text: '' },
          labels: {
            show: true,
            hideOverlappingLabels: true,

            formatter: (val) => {
              return this.$options.filters.formatDecimal(val);
            },
          },
        },
        stroke: {},
      };
    },

    setAmChart(data){
      let chartData = {
        mus:[],
        columns:['Date'],
        sources:[],
        values: []
      }
      this.consumption.forEach((consum, index) =>{
        if(index == 0){
          chartData.mus = consum.mus;
          chartData.columns.push(moment(this.consumption[index].values[0][0]).format(YEAR_FORMAT))
          // chartData.columns = consum.columns;
          chartData.sources = consum.sources;
          chartData.values = consum.values;
        } else {
          // chartData.columns.push(consum.columns[index]);
          chartData.columns.push(moment(this.consumption[index].values[0][0]).format(YEAR_FORMAT))
          chartData.sources.push(consum.sources[0]+index);

          for(let i=0; i < consum.values.length; i++ ){
            chartData.values[i].push(consum.values[i][index])
          }
        }
      });
      chartData.sources = [...new Set(chartData.sources)];
      this.unload();
      this.makeChart(this.chartId, chartData)
    },
    makeChart( chartId, data) {
      this.colors = this.$store.state.colors;
      let chart = am4core.create(chartId, am4charts.XYChart);
      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      chart.colors.list = this.colors.map( e => {
        return  am4core.color(e)
      })

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.cursorTooltipEnabled = false;
      dateAxis.renderer.grid.template.disabled = true;
      dateAxis.dateFormats.setKey("day", "dd MMM");
      dateAxis.renderer.minGridDistance = 30;
      dateAxis.renderer.cellStartLocation = 0.2
      dateAxis.renderer.cellEndLocation = 0.8

      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarX.parent = chart.bottomAxesContainer;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      // chart.numberFormatter.numberFormat = "#.";
      chart.legend = new am4charts.Legend();
      chart.exporting.menu = new am4core.ExportMenu();
      chart.series.clear();
      this.yAxis = {};
      data.mus.forEach((mu, index) => {
        if(! this.yAxis[mu]) {
          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.min = 0;
          valueAxis.name = data.columns[index + 1];
          valueAxis.title.text = `[[${mu}]]`;
          valueAxis.title.fontWeight = 600;
          // valueAxis.fill = am4core.color(this.colors[index % this.colors.length]);
          valueAxis.cursorTooltipEnabled = false;

          this.yAxis[mu] = valueAxis;
        }
      });
      this.createSeries(data,chart);
    },

    createSeries(data,chart){
      try{
        data.sources.forEach((source, index) => {
          let series = chart.series.push(new am4charts.ColumnSeries());

          let seriesColor = this.colors[  index % this.colors.length];
          series.dataFields.valueY = source;
          series.tooltip.pointerOrientation = "vertical";
          series.name = data.columns[index+1];
          series.dataFields.dateX = "date";
          series.columns.template.width = am4core.percent(100);


          // series.tooltip.label.propertyFields.fill = am4core.color('#FFFFFF');

          series.connect = false;
          series.tooltip.getFillFromObject = false;
          series.tooltip.autoTextColor = false;
          series.adapter.add("tooltipText", (text, target) => {
            let tooltipData = target.tooltipDataItem.dataContext;
            var sum=target.tooltipDataItem.dataContext;
            var num=[];
            num.push(sum.value.toString().split('.'));
            var valueY = num[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
            let strokeColor = target.stroke.hex;
            let dateFormat = this.getTooltipFormat(tooltipData.isComparing);
            var text = `${dateFormat}  \n [${strokeColor}]● [/] ${tooltipData.name} [bold]${valueY}[/]`
            return text;
           });

          series.tooltip.label.fill = am4core.color("black");
          var series_data = [];

          data.values.forEach((item, valueIndex) => {
            var dataItem = {};
            dataItem.value =  item[index + 1] ?   item[index + 1].toFixed(2) : 0;
            dataItem.name = data.columns[index+1]
            dataItem.date = new Date(item[0]);

            dataItem[source] = item[index + 1];
            series_data.push(dataItem);
          })
          series.data = series_data;
        });
        this.chart = chart;
      }
      catch(error){

      }
    },

    getTooltipFormat(){
      return'{dateX.formatDate("MMM")}' ;
    },

    unload() {
      if(this.chart){
        this.chart.dispose();
        this.chart = undefined;
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/ConsumptionMonthly.vue